import {validateJobScheduleInput} from './job-schedule-validation'

export type TimeEntryValidationInput = {
    startDate: Date | null
    startTime: string | null
    endDate: Date | null
    endTime: string | null
}

export function validateTimeEntryInput(input: TimeEntryValidationInput): Record<string, string> {
    const errors = validateJobScheduleInput({
        ...input,
        requireStartDate: true,
    })

    if (!input.startTime) {
        errors.startTime = 'Start time is required'
    }
    if (!input.endDate) {
        errors.endDate = 'End date is required'
    }
    if (!input.endTime) {
        errors.endTime = 'End time is required'
    }

    return errors
}
